module.exports = __webpack_public_path__ + "static/img/item_j_cherry.800fa5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item_j_cherry.png
// module id = KAJr
// module chunks = 1